import { Dialog, Transition } from '@headlessui/react';
import {
  IconAlertTriangle,
  IconCopy,
  IconCheck,
  IconTrash,
  IconPhoto,
  IconX,
  IconLoader2,
} from '@tabler/icons-react';
import { Fragment, useState, useEffect } from 'react';
import { imageBaseUrl } from '../../config/http';

export default function ConfirmationDeleteItem({
  isDelete,
  isOpenModalDelete,
  deleteBarang,
  setKeterangan,
  barangDelete,
  closeModaDelete,
  isRequest = false,
  customTitle = '',
}) {
  const [localKeterangan, setLocalKeterangan] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (isOpenModalDelete) {
      setLocalKeterangan('');
      if (setKeterangan) setKeterangan('');
      setCopied(false);
    }
  }, [isOpenModalDelete, setKeterangan]);

  const handleKeteranganChange = (e) => {
    const val = e.target.value;
    setLocalKeterangan(val);
    if (setKeterangan) setKeterangan(val);
  };

  const handleCopyCode = (code) => {
    if (!code) return;
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getImageUrl = (img) => {
    if (!img) return null;
    if (Array.isArray(img) && img.length > 0) {
      const src = img[0]?.thumbnail || img[0]?.asli;
      if (src) return `${imageBaseUrl}${src}`;
    }
    if (typeof img === 'string' && img !== 'Tidak ada gambar' && img.trim()) {
      return `${imageBaseUrl}${img}`;
    }
    return null;
  };

  const formatBerat = (berat) => {
    if (berat === null || berat === undefined || isNaN(Number(berat))) return '0.000';
    return Number(berat).toFixed(3);
  };

  const imageUrl = getImageUrl(barangDelete?.gambar1 || barangDelete?.gambar);
  const title = customTitle || (isRequest ? 'Pengajuan Hapus Barang' : 'Konfirmasi Hapus Barang');
  const actionButtonText = isDelete
    ? 'Memproses...'
    : isRequest
    ? 'Ajukan Hapus'
    : 'Hapus Barang';

  const namaJenis = barangDelete?.jenis_kategori?.nama_jenis || barangDelete?.nama_barang || 'Barang';
  const namaKategori = barangDelete?.jenis_kategori?.kategori?.nama_kategori || barangDelete?.kategori?.nama_kategori || '';
  const kodeItem = barangDelete?.kode_item || '-';
  const berat = formatBerat(barangDelete?.berat);
  const karat = barangDelete?.karat || '-';
  const baki = barangDelete?.nomor_rak ? `Baki ${barangDelete.nomor_rak}` : '-';
  const cabang = barangDelete?.cabang?.nama_cabang || '-';

  return (
    <Transition appear show={isOpenModalDelete} as={Fragment}>
      <Dialog as="div" className="relative z-[99999]" onClose={isDelete ? () => {} : closeModaDelete}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/20 dark:bg-black/40 pointer-events-auto transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden pointer-events-none">
          <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300 sm:duration-400"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300 sm:duration-400"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="pointer-events-auto w-screen max-w-full sm:max-w-lg transform overflow-y-auto bg-white dark:bg-slate-900 p-6 text-left align-middle shadow-2xl transition-all border-l border-slate-200 dark:border-slate-800 h-screen max-h-screen flex flex-col">
                {/* Header */}
                <div className="flex items-start justify-between pb-4 border-b border-slate-100 dark:border-slate-800">
                  <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-xl bg-rose-100 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400 flex items-center justify-center shrink-0 border border-rose-200 dark:border-rose-800/40">
                      <IconTrash size={22} stroke={2} />
                    </div>
                    <div>
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-bold text-slate-900 dark:text-slate-100"
                      >
                        {title}
                      </Dialog.Title>
                      <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                        {isRequest
                          ? 'Pengajuan penghapusan barang ini akan dikirim ke Admin/Owner'
                          : 'Periksa detail barang sebelum melakukan tindakan penghapusan'}
                      </p>
                    </div>
                  </div>
                  <button
                    disabled={isDelete}
                    onClick={closeModaDelete}
                    className="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer"
                  >
                    <IconX size={20} />
                  </button>
                </div>

                {/* Content */}
                <div className="mt-4 space-y-4">
                  {/* Card Detail Item */}
                  <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4 border border-slate-200/80 dark:border-slate-700/70">
                    <div className="flex items-center gap-3.5">
                      {/* Thumbnail Image */}
                      <div className="w-16 h-16 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden shadow-xs">
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt={namaJenis}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div className="flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
                            <IconPhoto size={24} stroke={1.5} />
                            <span className="text-[9px] mt-0.5 leading-none">No image</span>
                          </div>
                        )}
                      </div>

                      {/* Title, Category & Monospace Code */}
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2 flex-wrap">
                          <h4 className="font-bold text-slate-800 dark:text-slate-100 text-base leading-tight truncate">
                            {namaJenis}
                          </h4>
                          {namaKategori && (
                            <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800/40 shrink-0">
                              {namaKategori}
                            </span>
                          )}
                        </div>

                        {/* Kode Item with Copy Button */}
                        <div className="mt-1.5 flex items-center gap-1.5">
                          <span className="text-xs text-slate-500 dark:text-slate-400">Kode:</span>
                          <span className="font-mono text-xs font-bold px-2 py-0.5 rounded bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-slate-700 tracking-wide">
                            {kodeItem}
                          </span>
                          <button
                            type="button"
                            onClick={() => handleCopyCode(kodeItem)}
                            className="p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors cursor-pointer"
                            title="Salin Kode Item"
                          >
                            {copied ? (
                              <IconCheck size={14} className="text-emerald-500" />
                            ) : (
                              <IconCopy size={14} />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Grid Specs (Berat, Karat, Baki, Cabang) */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 mt-3 pt-3 border-t border-slate-200/70 dark:border-slate-700/60">
                      <div className="bg-white dark:bg-slate-800/80 rounded-lg p-2 border border-slate-200/60 dark:border-slate-700/50">
                        <span className="block text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          Berat
                        </span>
                        <span className="text-sm font-bold text-amber-600 dark:text-amber-400">
                          {berat} <span className="text-xs font-normal text-slate-500 dark:text-slate-400">gr</span>
                        </span>
                      </div>

                      <div className="bg-white dark:bg-slate-800/80 rounded-lg p-2 border border-slate-200/60 dark:border-slate-700/50">
                        <span className="block text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          Kadar
                        </span>
                        <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                          {karat} <span className="text-xs font-normal text-slate-500 dark:text-slate-400">K</span>
                        </span>
                      </div>

                      <div className="bg-white dark:bg-slate-800/80 rounded-lg p-2 border border-slate-200/60 dark:border-slate-700/50">
                        <span className="block text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          Posisi
                        </span>
                        <span className="text-sm font-semibold text-slate-700 dark:text-slate-200 truncate block" title={baki}>
                          {baki}
                        </span>
                      </div>

                      <div className="bg-white dark:bg-slate-800/80 rounded-lg p-2 border border-slate-200/60 dark:border-slate-700/50">
                        <span className="block text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          Lokasi
                        </span>
                        <span className="text-sm font-semibold text-slate-700 dark:text-slate-200 truncate block" title={cabang}>
                          {cabang}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Warning Note */}
                  <div className="flex items-start gap-2 text-xs text-amber-700 dark:text-amber-300/90 bg-amber-50 dark:bg-amber-950/30 p-2.5 rounded-lg border border-amber-200/80 dark:border-amber-800/40">
                    <IconAlertTriangle size={16} className="shrink-0 mt-0.5 text-amber-600 dark:text-amber-400" />
                    <span>
                      {isRequest
                        ? 'Permohonan akan ditinjau oleh Admin/Owner sebelum barang benar-benar dihapus dari sistem.'
                        : 'Tindakan ini akan menghapus data barang dari etalase / brankas aktif. Pastikan alasan dicatat dengan jelas.'}
                    </span>
                  </div>

                  {/* Textarea Alasan */}
                  <div>
                    <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                      Alasan {isRequest ? 'Pengajuan Hapus' : 'Penghapusan'}{' '}
                      <span className="text-rose-500 font-bold">* (Wajib diisi)</span>
                    </label>
                    <textarea
                      name="keterangan"
                      rows={3}
                      value={localKeterangan}
                      onChange={handleKeteranganChange}
                      disabled={isDelete}
                      placeholder={`Contoh: Rusak / Cacat produksi / Salah input kode / Permintaan peleburan...`}
                      className={`w-full px-3 py-2 text-sm rounded-lg border bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder-slate-400 dark:placeholder-slate-500 transition-all outline-none focus:ring-2 ${
                        !localKeterangan.trim()
                          ? 'border-slate-300 dark:border-slate-700 focus:border-rose-400 focus:ring-rose-500/20'
                          : 'border-emerald-300 dark:border-emerald-700 focus:border-emerald-400 focus:ring-emerald-500/20'
                      }`}
                    />
                    {!localKeterangan.trim() && (
                      <p className="text-[11px] text-rose-500 mt-1">
                        * Alasan harus diisi untuk dapat menekan tombol {actionButtonText}.
                      </p>
                    )}
                  </div>
                </div>

                {/* Footer Buttons */}
                <div className="mt-6 flex items-center justify-end gap-2.5 pt-4 border-t border-slate-100 dark:border-slate-800">
                  <button
                    type="button"
                    disabled={isDelete}
                    onClick={closeModaDelete}
                    className="px-4 py-2 text-sm font-medium rounded-lg text-slate-700 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 transition-colors disabled:opacity-50 cursor-pointer"
                  >
                    Batal
                  </button>

                  <button
                    type="button"
                    disabled={isDelete || !localKeterangan.trim()}
                    onClick={deleteBarang}
                    className="px-5 py-2 text-sm font-medium rounded-lg text-white bg-rose-600 hover:bg-rose-700 active:bg-rose-800 shadow-sm transition-all flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    {isDelete ? (
                      <>
                        <IconLoader2 size={16} className="animate-spin" />
                        <span>Memproses...</span>
                      </>
                    ) : (
                      <>
                        <IconTrash size={16} />
                        <span>{actionButtonText}</span>
                      </>
                    )}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
